import PolicyDoc from '@/components/PolicyDoc';
import { TERMS } from '@/shared/policy';

export const route = { path: '/terms', layout: 'public', access: 'public' };

export default function Terms() {
  return <PolicyDoc doc={TERMS} />;
}
